import PropTypes from "prop-types";
import { Button, Checkbox, Select, SettingsCard, Space } from "top-component-library";
import { FormRow, SettingHint } from "../styles";

// Mirrors editCustomerProperties.html's "External Vendor Setup" card.
const ExternalVendorsCard = ({
  customerId,
  vendors,
  allowedCustomers,
  changed,
  saving,
  onAddVendor,
  onRemoveVendor,
  onUpdateVendorField,
  onSave,
}) => {
  const addedVendorIds = vendors.map((vendor) => vendor.customer_id);
  const selectableCustomers = allowedCustomers.filter(
    (option) => option.customer_id !== customerId && !addedVendorIds.includes(option.customer_id)
  );

  return (
    <SettingsCard title="External Vendor Setup">
      <SettingHint>
        Menus from these other customers can be offered at your locations. After adding a vendor here, use the Delivery
        Location editor to precisely control which menus are at which locations.
      </SettingHint>
      {vendors.map((vendor) => (
        <FormRow key={vendor.customer_id}>
          <label>{vendor.name_for_admin}</label>
          <Space direction="vertical">
            {vendor.isNew && (
              <Checkbox
                checked={vendor.addAllMenus}
                onChange={(event) => onUpdateVendorField(vendor.customer_id, "addAllMenus", event.target.checked)}
              >
                Add all their menus to all my locations now
              </Checkbox>
            )}
            <Checkbox
              checked={vendor.vendee_sees_vendor_data}
              onChange={(event) =>
                onUpdateVendorField(vendor.customer_id, "vendee_sees_vendor_data", event.target.checked)
              }
            >
              Allow vendee to view vendor&apos;s data
            </Checkbox>
            <Checkbox
              checked={vendor.vendee_loyalty_api_controls_vendors}
              onChange={(event) =>
                onUpdateVendorField(vendor.customer_id, "vendee_loyalty_api_controls_vendors", event.target.checked)
              }
            >
              Allow vendee&apos;s loyalty program (if any) to discount vendor&apos;s items
            </Checkbox>
          </Space>
          <Button danger onClick={() => onRemoveVendor(vendor.customer_id)}>
            Remove
          </Button>
        </FormRow>
      ))}
      <FormRow>
        <label htmlFor="customer-properties-add-vendor">Add vendor</label>
        <Select
          id="customer-properties-add-vendor"
          value={undefined}
          onChange={(customerIdToAdd) =>
            onAddVendor(selectableCustomers.find((option) => option.customer_id === customerIdToAdd))
          }
        >
          {selectableCustomers.map((option) => (
            <Select.Option key={option.customer_id} value={option.customer_id}>
              {option.name_for_admin}
            </Select.Option>
          ))}
        </Select>
      </FormRow>
      <Button type="primary" loading={saving} disabled={!changed} onClick={onSave}>
        Save vendors
      </Button>
    </SettingsCard>
  );
};

ExternalVendorsCard.propTypes = {
  customerId: PropTypes.string,
  vendors: PropTypes.arrayOf(
    PropTypes.shape({
      customer_id: PropTypes.string.isRequired,
      name_for_admin: PropTypes.string.isRequired,
      isNew: PropTypes.bool.isRequired,
      addAllMenus: PropTypes.bool.isRequired,
      vendee_sees_vendor_data: PropTypes.bool.isRequired,
      vendee_loyalty_api_controls_vendors: PropTypes.bool.isRequired,
    })
  ).isRequired,
  allowedCustomers: PropTypes.arrayOf(
    PropTypes.shape({ customer_id: PropTypes.string.isRequired, name_for_admin: PropTypes.string.isRequired })
  ).isRequired,
  changed: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  onAddVendor: PropTypes.func.isRequired,
  onRemoveVendor: PropTypes.func.isRequired,
  onUpdateVendorField: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

ExternalVendorsCard.defaultProps = {
  customerId: undefined,
};

export default ExternalVendorsCard;
